import { Injectable } from '@angular/core';
import { DateService } from 'src/app/services/date.service';
import { GeneralService } from 'src/app/services/general.service';

@Injectable({
  providedIn: 'root',
})
export class MenuRestaurantService {
  DS_menuRestaurant;
  list_restaurants = [];
  list_menu_byResto = [];
  list_TarifsRestaurantDipsonible = [];
  constructor(
    private generalService: GeneralService,
    private dateService: DateService
  ) {
    this.getDs_menuRestaurant();
  }

  getDs_menuRestaurant() {
    this.generalService.getDS('Menu_RestaurantD').subscribe((data) => {
      console.log(data);
      this.DS_menuRestaurant = data;
    });
    this.generalService.getDS('Menu_Tarif').subscribe((data) => {
      console.log(data);
    });
  }

  saveMenu_Restaurant() {
    if (this.DS_menuRestaurant)
      this.generalService.postDs(this.DS_menuRestaurant).subscribe(
        (res) => {
          console.log(res);
          this.generalService.dialogSuccess('Menu enregistré', true);
        },
        (err) => {
          this.generalService.dialogSuccess('Menu non enregistré', false);
        }
      );
  }

  getRestaurants() {
    this.generalService
      .rechercheTable2('batfour1')
      .subscribe((Fournisseurs: any) => {
        this.list_restaurants = Fournisseurs.filter(
          (four) => four.Tiers_code[0] == 'R' && four.Tiers_code[1] != 'H'
        );
        console.log(this.list_restaurants);
      });
  }

  getMenuByRestaurant(restaurant) {
    var param = '0,' + restaurant.Tiers_code;
    if (restaurant) {
      this.generalService
        .rechercheTable2('Api_listeType', param)
        .subscribe((res: any) => {
          console.log(res);
          this.list_menu_byResto = res;
        });
    }
  }

  getTarifsRestaurantDipsonible(restaurant) {
    const dateDeb = new Date('01-01-2020');
    const dateFin = new Date();
    var param =
      this.dateService.setFormatDateRechercheServer(dateDeb) +
      ',' +
      this.dateService.setFormatDateRechercheServer(dateFin) +
      ',' +
      restaurant.Tier_code;

    if (restaurant) {
      this.generalService
        .rechercheTable2('API_Tarif', param)
        .subscribe((res: any) => {
          console.log(res);
          this.list_TarifsRestaurantDipsonible = res;
        });
    }
  }
}
